// JavaScript source code
import { useRef, useState } from 'react';
import GameImageHeader from './GameImageHeader';
import './styles/PlayerInfo.css';

function PlayerInfo() {

    return (
        <div className="playerPage">
            <div className="titleLine">
                <GameImageHeader />
                <div className="topBody">
                    <div className="infoPlayer">
                        <h2 className="taglineTopPlayer">Support A New Favorite Game</h2>
                        <h2 className="taglineBottomPlayer">Just By Playing It</h2>
                        <p className="subTagLinePlayer">Try a bunch of new games for one price.<br/>Support your favorites just by playing.</p>
                    </div>
                </div>
            </div>

            <div className="playerMessageContainer">
                <div className="playerInfo">
                    <div className="earlyAccessContainer">
                        <p className="earlyAccessText"></p>
                    </div>
                </div>
            </div>

            <div className="playerInfoContainer">
                <h1 className="playerSectionHeader">Why use Ludare?</h1>
                <div className="tileContainer">
                    <div className="signUpStep">
                        <img className="signUpIcon" src="/LibraryPhoto.png" />
                        <p className="signUpStepTitle">Support Early Games at Low Risk</p>
                        <p className="signUpTileInfo">With Ludare, you get access to a whole library that includes early-stage games at one low cost. This means that you can try and support an array of indie games just with your playtime, rather than putting $20 or $30 into a project that maybe you'll see in 5 years.</p>
                    </div>

                    <div className="paymentStep">
                        <img className="paymentIcon" src="/line-chart.png" />
                        <p className="paymentStepTitle">Influence What Games are Made</p>
                        <p className="paymentTileInfo">By driving revenue and information on how you play to early-stage games, studios are better equipped to make their games whether they are self-published or looking to attract a publisher.</p>
                    </div>
                    <div className="playStep">
                        <img className="playIcon" src="/favorite.png" />
                        <p className="playStepTitle">Find Your Next Favorite Game</p>
                        <p className="playTileInfo">Ludare is building the next generation of game recommendations that are based off your real play patterns. This means that you will have the newest games that you are likely to enjoy served up fresh right to you.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PlayerInfo;